// driver api
import getDriverRateAddonApi from '@drivesally/sally-fn/lib/driver/api/getRateAddon.api.driver';

// lib
import fkOrId from '@drivesally/sally-fw/lib/lib/fkOrId';
import sum from '@drivesally/sally-fw/lib/lib/sum';

// rental api
import getRentalByIdApi from '@drivesally/sally-fn/lib/rental/api/getByID.api.rental';

// vehicle api
import getVehicleByIdApi from '@drivesally/sally-fn/lib/vehicle/api/getByID.api.vehicle';

const getSuggestedRentalRateService = async ({rentalId}) => {
  try {
    const rental = await getRentalByIdApi(rentalId);
    const vehicle = await getVehicleByIdApi(fkOrId(fkOrId(rental.vehicle)));
    const vehicleRate = vehicle?.rate_card?.rate || 0;
    const driverRateResponse = await getDriverRateAddonApi(
      fkOrId(rental?.drivers?.[0]?.driver)
    );
    const driverRateAddon = Number(driverRateResponse?.rate) || 0;
    return sum(vehicleRate, driverRateAddon);
  } catch (error) {
    return 0;
  }
};

export default getSuggestedRentalRateService;
